module.exports = __webpack_public_path__ + "img/gb-eng.14167f77.svg";